import * as React from 'react'
import { cn } from '~/lib/utils'

export type LabelProps = React.ComponentProps<'label'>

/** 폼 라벨. */
function Label({ className, ref, ...props }: LabelProps) {
    return (
        <label
            ref={ref}
            data-slot='label'
            className={cn(
                'text-foreground text-[13px] font-medium select-none',
                className
            )}
            {...props}
        />
    )
}

export { Label }
